// Ethiopian calendar (requirements D-14). Verified reference implementation: sprint 1, Appendix B.
const JD_EPOCH_OFFSET = 1723856; // Amete Mihret

export type EthDate = { year: number; month: number; day: number }; // month 1–13

function gregorianToJdn(y: number, m: number, d: number): number {
  const a = Math.floor((14 - m) / 12);
  const y2 = y + 4800 - a;
  const m2 = m + 12 * a - 3;
  return (
    d +
    Math.floor((153 * m2 + 2) / 5) +
    365 * y2 +
    Math.floor(y2 / 4) -
    Math.floor(y2 / 100) +
    Math.floor(y2 / 400) -
    32045
  );
}

function jdnToGregorian(jdn: number): [number, number, number] {
  const a = jdn + 32044;
  const b = Math.floor((4 * a + 3) / 146097);
  const c = a - Math.floor((146097 * b) / 4);
  const d = Math.floor((4 * c + 3) / 1461);
  const e = c - Math.floor((1461 * d) / 4);
  const m = Math.floor((5 * e + 2) / 153);
  return [
    100 * b + d - 4800 + Math.floor(m / 10),
    m + 3 - 12 * Math.floor(m / 10),
    e - Math.floor((153 * m + 2) / 5) + 1,
  ];
}

function ethiopianToJdn({ year, month, day }: EthDate): number {
  return JD_EPOCH_OFFSET + 365 + 365 * (year - 1) + Math.floor(year / 4) + 30 * month + day - 31;
}

function jdnToEthiopian(jdn: number): EthDate {
  const r = (jdn - JD_EPOCH_OFFSET) % 1461;
  const n = (r % 365) + 365 * Math.floor(r / 1460);
  return {
    year: 4 * Math.floor((jdn - JD_EPOCH_OFFSET) / 1461) + Math.floor(r / 365) - Math.floor(r / 1460),
    month: Math.floor(n / 30) + 1,
    day: (n % 30) + 1,
  };
}

/** "2026-10-12" → { year: 2019, month: 2, day: 2 } */
export function toEthiopian(isoDate: string): EthDate {
  const [y, m, d] = isoDate.split('-').map(Number);
  return jdnToEthiopian(gregorianToJdn(y!, m!, d!));
}

/** { year: 2019, month: 2, day: 2 } → "2026-10-12" */
export function fromEthiopian(e: EthDate): string {
  const [y, m, d] = jdnToGregorian(ethiopianToJdn(e));
  return `${y}-${String(m).padStart(2, '0')}-${String(d).padStart(2, '0')}`;
}

export const isEthiopianLeapYear = (year: number) => year % 4 === 3; // Pagume has 6 days
export const daysInEthiopianMonth = (year: number, month: number) =>
  month < 13 ? 30 : isEthiopianLeapYear(year) ? 6 : 5;
